import React, { useEffect, useState } from "react";
import TableWrapper from "../../core/BaseComponents/TableWrapper/TableWrapper";
import { callAPI } from "../../../axios";
import { CircularProgress, Tooltip } from "@mui/material";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { getChainIdLS } from "../../../utils/utils";

const STBApkDetails = (props) => {
    const {sid, cdsn, flag} = props
    const [stbApkDetails, setStbApkDetails] = useState({});
    const [loader, setLoader] = useState(false);

    const [apkDetailsFetchNowLoader, setApkDetailsFetchNowLoader] = useState(false)

    const { viewType } = useSelector((state) => state.viewTypeReducer);

    // const renderFetchNow = (row) => {
    //     return <Tooltip title="Fetch Now" arrow>
    //         <div className="py-2">
    //             <button type="button" className="opacity-50 pe-none un-published"> Fetch Now </button>
    //         </div>
    //     </Tooltip>
    // }
   
    const triggerFetchNow = ()=>{
        setApkDetailsFetchNowLoader(true)
        callAPI(`/fetch?sid=${sid}&cdsn=${cdsn}&pageTitle=STB APK details`, "GET", {}, { chainId: getChainIdLS() })
            .then(function (response) {
                setStbApkDetails(response)
                setApkDetailsFetchNowLoader(false)
            })
            .catch(function (error) {
                console.warn(error.response?.data?.errorMessage);
                setApkDetailsFetchNowLoader(false)
            });
    }

    const columns = [
        { field: "appName", headerName: "App Name", flex: 1 },
        { field: "appPackage", headerName: "App Package", flex: 1 },
        { field: "appVersion", headerName: "App Version", flex: 1 },
        { field: "versionCode", headerName: "Version Code", flex: 1 },
        // {
        //     field: 'fetchNow', headerName: 'Fetch Now', flex: 1, row: true, renderCell: renderFetchNow, disableSortIcon: true,
        // },
    ];

    useEffect(() => {
        if (viewType === "hotelApp") {
            if (sid !== "" && cdsn !== "") {
                setLoader(true);
                callAPI(`/cdsn-info?sid=${sid}&cdsn=${cdsn}&pageTitle=STB APK details`, "GET", {}, { chainId: getChainIdLS() })
                    .then(function (response) {
                        setStbApkDetails(response);
                        setLoader(false);
                    })
                    .catch(function (error) {
                        console.warn(error.response?.data?.errorMessage);
                        setLoader(false);
                    });
            }
        }
    }, [sid, cdsn, flag])

    return (
        <div className='config-hotel my-3'>
            {loader && <div className="circular-progress"><CircularProgress /></div>}
            {viewType === "hotelApp" && <div className='left-column'>
                <div className="hotel-list">
                    <div className="d-flex justify-content-between">
                        <p><b>STB APK Details </b>
                            ( Last Updated: {stbApkDetails?.lastUpdated === null ? "N.A" : dayjs(stbApkDetails?.lastUpdated).format("DD MMM YYYY | hh:mm A")})
                        </p>
                        <Tooltip title={`${apkDetailsFetchNowLoader ? "Fetch Now in Progress" : "Fetch Now"}`} arrow>
                            <div className="py-2">
                                <button onClick = {triggerFetchNow}  type="button" className={`${apkDetailsFetchNowLoader?"opacity-50 pe-none":""} un-published`}>
                                    {apkDetailsFetchNowLoader?<img
                                    src="/Images/rotate.png"
                                    width="25"
                                    className="loaderIcon mr-1"
                                    />:""} Fetch Now </button>
                            </div>
                        </Tooltip>
                    </div>
                    <TableWrapper
                        data={stbApkDetails?.value}
                        columns={columns}
                        noPagination={true}
                        noDataAvailable="Specific mapped third party app details not available on the STB"
                    />
                </div>
            </div>}
        </div>
    )
}

export default STBApkDetails;